import { render, staticRenderFns } from "./PointTierForm.vue?vue&type=template&id=22bf5dfb&scoped=true"
import script from "./PointTierForm.vue?vue&type=script&lang=js"
export * from "./PointTierForm.vue?vue&type=script&lang=js"
import style0 from "./PointTierForm.vue?vue&type=style&index=0&id=22bf5dfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf5dfb",
  null
  
)

export default component.exports